import { NotificationDispatch } from '@tryhackme/thm-ui-components';
import { useCallback, useState } from 'react';

import { useLazyDownloadVpnConfigQuery } from 'src/features/room/room.slice';

import { useTrackDownloadOVPNMutation } from '../slices/analytics/download-ovpn';

export const useDownloadVpnConfig = (networkId?: string) => {
  const [isDownloadLoading, setIsDownloadLoading] = useState(false);

  const [download] = useLazyDownloadVpnConfigQuery();
  const [trackDownloadOVPN] = useTrackDownloadOVPNMutation();

  const handleDownloadVpnConfig = useCallback(async () => {
    try {
      setIsDownloadLoading(true);
      const result = await download(networkId, false);
      await trackDownloadOVPN('access_machines_modal');
      if (!result.data?.data?.url) {
        throw new Error('Error downloading VPN config');
      }
      window.location.href = result.data.data.url;
    } catch {
      NotificationDispatch('error', 'Error downloading VPN config');
    } finally {
      setIsDownloadLoading(false);
    }
  }, [download, networkId, setIsDownloadLoading, trackDownloadOVPN]);

  return {
    handleDownloadVpnConfig,
    isDownloadLoading,
  };
};
